import $http from '@/api';

/**
 * @typedef {{}} ClippingCard
 * @property {number} id -
 * @property {string} name -
 * @property {string} alias -
 * @property {string} src -
 * @property {ContentBaseCard} image -
 */

/**
 * Searches for the clippings of the image that matches the given aspect ratios.
 * @param {number} id - Image identifier.
 * @param {string[]} aspectRatios - Aspect ratios searched for.
 * @return {Promise.<ClippingCard[]>}
 */
const clippingSearch = async ({ id }, aspectRatios = []) => {
  const payload = {};
  if (aspectRatios.length) payload.aspectRatios = aspectRatios;
  const response = await $http.post(`/api/content/image/${id}/clippings`, payload);
  return response.results;
};

/**
 * Gets an image resource
 * @param {integer} id - The image identifier.
 * @return {ContentCard}
 */
const getImage = async ({ id }) => $http.get(`/api/content/image/${id}`);

/**
 * Creates a clipping with the given options.
 * @param {{contentId: integer, alias: string, operations:[]}} payload
 * @return {ClippingCard}
 */
const createClipping = async payload => $http.post('/api/clipping', payload);

const getClipping = async id => $http
  .get(`/api/clipping/${id}`)
  .catch((e) => {
    console.warn(`Error while getting clipping with id ${id}`, e);
    return null;
  });

export default {
  clippingSearch,
  getImage,
  createClipping,
  getClipping,
};
